import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import styles from './styles.module.scss'

/* Constants */
import { ROUTES } from 'lib/constants'

/* Components */
import { NavigationMenu } from 'backoffice/Main'

/* Assets */
import PoapLogo from 'images/POAP.svg'
import chevronLeft from 'images/chevron-left.svg'

const GoBackButton = () => {
  return (
    <Link to={ROUTES.admin} className={styles.goBackButton}>
      <img src={chevronLeft} alt="Back to admin" />
      <strong>Back to admin</strong>
    </Link>
  )
}

/* @ts-ignore TODO: remove ignore TS validation */
const Layout: React.FC = ({ children }) => {
  const location = useLocation()

  return (
    <>
      <header id="site-header" role="banner">
        <div className="container">
          <div className="col-xs-5 col-md-6">
            <Link to={ROUTES.admin} className="logo">
              <img src={PoapLogo} alt="POAP" />
            </Link>
          </div>
          <div className="col-xs-7 col-md-6">
            <p className="page-title">Back Office</p>
          </div>
        </div>
      </header>
      <main className="app-content backoffice">
        <div className="container">
          {location.pathname !== ROUTES.admin && (
            <div className="bk-container">
              <GoBackButton />
            </div>
          )}
          {children}
        </div>
      </main>
      <NavigationMenu />
    </>
  )
}

export default Layout
